import MaterialIcon from "../../../../../MaterialIcon";
import React from "react";

export const InputActionArea = (props) => {
    const {value, editButton, removePort, inputListCount} = props;
    return (
        <div className="action-area">
            <button className={`edit-button ${value.edit ? 'active' : ''}`} onClick={() => editButton(value)}>
                Edit
                <MaterialIcon icon="keyboard_arrow_down" size={24}/>
            </button>
            {
                (inputListCount === undefined || inputListCount === true) &&
                <button className="remove-button round" onClick={() => removePort(value)}>
                    <MaterialIcon icon="close"/>
                </button>
            }
        </div>
    )
}